<section class="hide-for-print section other-valuable-benefits">
  <h2 [innerText]="'Other Valuable Benefits' | translate"
  class="secondary-heading secondary-heading--white"></h2>
  <p [innerText]="'At SOLV Energy, your wellbeing comes first. We understand that your needs go beyond medical and financial benefits. That’s why we offer you an array of other benefit options to choose from—so you and your family will always have the support you need.'
        | translate"
  class="other-valuable-benefits__subheading"></p>
  <div class="other-valuable-benefits__cards">
    @for (valuableBenefit of valuableBenefits; track valuableBenefit) {
      <div class="other-valuable-benefits__cards__card">
        <div class="other-valuable-benefits__cards__card__top">
          <h4 [innerText]="ValuableBenefitsData[valuableBenefit].heading"
          class="other-valuable-benefits__cards__card__top__heading"></h4>
          <p [innerText]="ValuableBenefitsData[valuableBenefit].description"
          class="other-valuable-benefits__cards__card__top__description"></p>
        </div>
        <a [href]="ValuableBenefitsData[valuableBenefit].link" target="_blank"
          class="btn--clean-green other-valuable-benefits__cards__card__action">
          <span
          [innerText]="ValuableBenefitsData[valuableBenefit].linkLabel ?? 'Visit provider'"></span>
          <img alt="Visit provider" height="15" ngSrc="/assets/img/icons/external-link-icon.svg"
            width="15" />
        </a>
      </div>
    }
  </div>
</section>

<!--Blank page added after Other Valuable Benefits and before back cover when odd number of pages present-->
@if (isBlankPageNeededForPdf) {
  <section class="section--pdf-blank pdf-page-wrapper"></section>
}
